























































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import QuestionModal from './question/questionModal.vue'
import listMixins from '@/mixins/list'
import { columns } from './question/config'
import RevisitApi from '@/api/revisit'
import { cloneDeep } from 'lodash'

@Component({
	name: 'revisitQuestions',
	components: {
		PageLayout,
		QuestionModal,
	},
})
export default class RevisitQuestions extends Mixins(listMixins) {
	private visible = false
	private columns = columns
	private data: any[] = []
	private currentQuestion: any = null

	private onFinish() {
		// 新增/编辑成功回调
		this.getList()
	}

	private showModal(row: any) {
		this.visible = true
		// 保证每次均触发Watch
		this.currentQuestion = row && cloneDeep(row)
	}

	private deleteQuestion(id: string) {
		RevisitApi.removeQuestionCheck(id).then((res: any) => {
			const data = res && res.data
			if (data.canDelFlag === '0') {
				// 当前题目不可被删除
				let templateNames = (data.templateList || [])
					.map((template: any) => template.templateName)
					.join('、')
				this.$info({
					title: '提示',
					okText: '我知道了',
					content: (h: any) => {
						return h('div', {}, [
							h(
								'span',
								{
									style: {
										color: '#ff0000',
									},
								},
								'删除失败'
							),
							h('span', {}, `，该题目正在使用，引用问卷“${templateNames}”`),
						])
					},
				})
			} else if (data.canDelFlag === '1') {
				this.$confirm({
					content: '请确定是否删除该题目？',
					onOk: () => {
						return RevisitApi.removeQuestion(id).then((res: any) => {
							this.$message.success('删除成功')
							this.getList()
						})
					},
				})
			}
		})
	}

	public getList() {
		return RevisitApi.getQuestionList(this.getSearchValues()).then(
			(res: any) => {
				const data = (res && res.data) || {}
				this.total = data.count
				this.data = data.retList
			}
		)
	}

	public activated() {
		this.getList()
	}
}
